/**
 * Dispara um download no navegador sem perder o "user gesture" — o que
 * `window.open` faz com frequência após um `await`. Cria um `<a download>`
 * invisível, força o clique e remove. Funciona tanto para presigned URLs
 * (que retornam Content-Disposition: attachment) quanto para endpoints
 * internos protegidos por cookie HTTP-only.
 */
export function triggerBrowserDownload(url: string, fileName?: string): void {
  const link = document.createElement('a');
  link.href = url;
  if (fileName) link.download = fileName;
  link.rel = 'noopener';
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
